import { Outlet } from 'react-router'

const BillingMainLayout = () => {
  return (
    <Outlet />
  )
}

export default BillingMainLayout